import axios from '@store/axios'
import parseUrl from '@/core/helpers/parseUrl'

export default {
  getUploadInfo({ commit }, id) {
    const url = parseUrl('/upload/request/:id', { id })
    return axios.get(url).then(({ data }) => {
      commit('setUploadInfo', data)
      return data
    })
  },
  // TODO:
  getProvider({ commit }, id) {
    const url = parseUrl('/upload/request/:id', { id })
    return axios.get(url).then(({ data }) => {
      commit('setDateOfCare', data)
      return data
    })
  },
  getPatientUploadURL({ commit }, { patientId, renderingProvider, mimetype, encounterDate, recordType, description }) {
    if (renderingProvider === null) {
      renderingProvider = undefined
    }

    if (encounterDate === null) {
      encounterDate = undefined
    }

    if (recordType === null) {
      recordType = undefined
    }

    if (description === null) {
      description = undefined
    }

    const url = parseUrl('/patients/:id/files', { id: patientId })
    return axios.post(url, { mimetype, renderingProvider, encounterDate, recordType }).then(({ data }) => {
      commit('setPatientUploadURL', data)
      return data
    })
  },
  getPatientUploadInfo({ commit }, id) {
    const url = parseUrl('/patients/:id', { id })
    return axios.post(url).then(({ data }) => {
      commit('setPatientInformation', data)
      return data
    })
  },
  getUploadURL({ commit }, { request, mimetype }) {
    const url = '/file'
    return axios
      .post(url, {
        request,
        mimetype
      })
      .then(({ data }) => {
        commit('setUploadURL', data)
        return data
      })
  },
  initUploadGoogleStorage({ commit }, { url, type }) {
    var request = new Request(url, {
      method: 'POST',
      redirect: 'follow',
      headers: new Headers({
        'Content-Type': type,
        'x-goog-resumable': 'start'
      })
    })
    return fetch(request).then(data => {
      console.log('returning freaking data')
      console.log(data)
      return data
    })
  },
  getUploadFailPosition({ commit }, { url, uploadSize }) {
    console.log('fail position')
    console.log(url)
    var request = new Request(url, {
      method: 'PUT',
      redirect: 'follow',
      headers: new Headers({
        'Content-Range': 'bytes */' + uploadSize
      })
    })
    return fetch(request).then(data => {
      console.log('returning freaking data')
      console.log(data)
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/upload/actions.js